import styled from 'styled-components';

const Title = styled.h2`
  font-size: 2rem;
  font-weight: bold;

  margin-block-start: 1rem;
  margin-block-end: 2rem;
`;

export default Title;
